import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";
import "../../css/service.page.css";

import { ContainerNoBg } from "../../components/container.no.bg";
import { Clickable } from "../../components/clickable.container";
import { useIsMobile } from "../../hooks/is.mobile";
import { ImportAll } from "../../utils/utils";
import { useNavigate } from "react-router-dom";

const images = ImportAll(
  require.context("../../assets/services", false, /\.(png|jpe?g|svg)$/),
);

export const Services: React.FC<any> = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  return (
    <div>
      <ContainerNoBg>
        <div
          style={{
            paddingLeft: isMobile ? "0" : "4.5vw",
            paddingBottom: "1vw",
          }}
          className={
            "title-text-font" + " " + "text-align" + " " + "service-title-main"
          }
        ></div>
        <div
          style={{
            paddingLeft: "4.5vw",
            paddingRight: "4.5vw",
            paddingTop: isMobile ? "4vw" : "0",
          }}
        >
          <Clickable
            onclick={() => {
              navigate("/game-development");
            }}
            children={
              <div className="service-title-box">
                <div className={"title-text-font" + " " + "service-title"}>
                  GAME DEVELOPMENT
                </div>
                {isMobile ? (
                  ""
                ) : (
                  <div className={"service-appearing-text"}></div>
                )}
              </div>
            }
            style="service"
            backgroundUrl={images[0]}
          />
          <Clickable
            onclick={() => {
              navigate("/3dassets");
            }}
            children={
              <div className="service-title-box">
                <div className={"title-text-font" + " " + "service-title"}>
                  ASSETS/TOOLS
                </div>
                {isMobile ? (
                  ""
                ) : (
                  <div className={"service-appearing-text"}></div>
                )}
              </div>
            }
            style="service"
            backgroundUrl={images[1]}
          />
          {/* <Clickable
            onclick={() => {
              navigate("/development-tools");
            }}
            children={
              <div className="service-title-box">
                <div className={"title-text-font" + " " + "service-title"}>
                  TOOLS / SYSTEMS
                </div>
                {isMobile ? (
                  ""
                ) : (
                  <div className={"service-appearing-text"}></div>
                )}
              </div>
            }
            style="service"
            backgroundUrl={images[4]}
          /> */}
          <Clickable
            onclick={() => {
              navigate("/audio");
            }}
            children={
              <div className="service-title-box">
                <div className={"title-text-font" + " " + "service-title"}>
                  AUDIO DESIGN
                </div>
                {isMobile ? (
                  ""
                ) : (
                  <div className={"service-appearing-text"}></div>
                )}
              </div>
            }
            style="service"
            backgroundUrl={images[3]}
          />
          {/* <Clickable
            onclick={() => {
              navigate("/art3D");
            }}
            children={
              <div className="service-title-box">
                <div className={"title-text-font" + " " + "service-title"}>
                  3D ART
                </div>
                {isMobile ? (
                  ""
                ) : (
                  <div className={"service-appearing-text"}></div>
                )}
              </div>
            }
            style="service"
            backgroundUrl={images[2]}
          /> */}
        </div>
      </ContainerNoBg>
    </div>
  );
};
